// extracted by mini-css-extract-plugin
export default {"numericInput":"numeric-input_numericInput__noh8T","withLabel":"numeric-input_withLabel__hUM4Z"};